import { render, staticRenderFns } from "./CollegeUser.vue?vue&type=template&id=6e465eaf&scoped=true&"
import script from "./CollegeUser.vue?vue&type=script&lang=js&"
export * from "./CollegeUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e465eaf",
  null
  
)

export default component.exports